import Vue from 'vue'
import ActionTemplates from './ActionTemplates'
import axios from 'axios'
import Credentials from './Credentials'
import FakeParams from './FakeParams'
import NestedObject from './NestedObject'
import Api from './Api'
import WorkflowExecution from './WorkflowExecution'

import {defaultsDeep, mapValues} from 'lodash'


window.NestedObject = NestedObject

class WorkflowRunner {

  constructor(workflow) {
    this.workflow = workflow
    this.results = {}
    this.currentActionIndex = null
    this.bus = new Vue()
  }

  reset() {
    this.results = {}
    this.currentActionIndex = null
  }

  run(runtimeOptions) {
    this.reset()
    this.runtimeOptions = runtimeOptions
    this.bus.$emit('start')
    this.currentActionIndex = 0
    this.runNextAction()
  }

  requestHeaders() {
    return {
      'Authorization': Credentials.get(Api.defaultEnvironment)
    }
  }

  runNextAction() {
    let action = this.workflow.actions[this.currentActionIndex]
    if (!action) {
      this.finished()
      return
    }

    this.bus.$emit('start.action', action)

    let allTemplates = ActionTemplates.storage.allGrouped()
    let template = allTemplates[action.template_id]

    if (template.method == 'SelectWorkflow') {
      let uuid = this.runtimeOptions.selectedPreviousWorkflows[action.uuid]
      let previousExecution = WorkflowExecution.storage.find(uuid)
      if (previousExecution) {
        let params = _.mapValues(previousExecution.output, (item)=>{
          return item.value
        })
        this.processResult(action, template, {workflow: params})
      } else {
        this.handleNetworkError(action, {name: "Not Found", message: "Please select a previously executed workflow in order to proceed"})
      }
      return
    }

    let path = template.endpoint
    if (path.indexOf('{') >= 0) {
      let pathParams = this.generatePathParams(template, action)
      path = this.applyPathParams(path, pathParams)
    }

    let params = this.generateParams(template, action)
    let isGet = template.method.toUpperCase() == "GET"

    // // simulate
    // setTimeout(()=>{
    //   this.processResult(action, template, {success: true})
    // }, 1000)
    // return

    axios({
      method: template.method,
      url: `${Api.defaultHost}${path}`,
      data: isGet ? null : params,
      params: isGet ? params : null,
      headers: this.requestHeaders()
    }).then((response) => {
      this.processResult(action, template, response.data)
    }).catch((error) => {
      if (error.response && error.response.status == 422) {
        this.handleValidationError(action, error)
      } else {
        this.handleNetworkError(action, error)
      }
      this.bus.$emit('complete')
    })
  }

  handleValidationError(action, error) {
    let json = error.response.data
    this.bus.$emit('validation-error.action', action, json.errors || json.error)
  }

  handleNetworkError(action, error) {
    this.bus.$emit('network-error.action', action, error)
  }

  processResult(action, template, output) {
    this.results[action.uuid] = {
      mapping: template.output,
      output: output
    }
    this.currentActionIndex += 1

    this.bus.$emit('complete.action', action, output)
    setTimeout(()=>{
      Vue.nextTick(()=>{
        this.runNextAction()
      })
    }, template.timeout)
  }

  finished () {
    // this.workflow
    this.bus.$emit('complete', this.results)
  }

// helper
  applyPathParams(path, pathParams) {
    for (let [pathParamName, value] of Object.entries(pathParams)) {
      path = path.replace(new RegExp(`{${pathParamName}}`, "g"), value)
    }
    return path
  }

  generatePathParams(actionTemplate, action) {
    let pathParams = {}
    for(let inputName of actionTemplate.pathParams) {
      let outputReference = action.input_mapping[inputName]
      pathParams[inputName] = this.findPreviousOutput(outputReference)
    }
    return pathParams
  }

  // outputReference = "<output_id>_<param_name>"
  findPreviousOutput(outputReference) {
    if (!outputReference) {
      console.warn('output reference not found: ', outputReference)
      return
    }
    let outputId_outputName = outputReference.split("_")
    let outputId = outputId_outputName[0]
    let outputName = outputId_outputName.slice(1).join("_")

    // Find the nested key after which we will then be search in the output
    // resultKey = "provider.id"
    // value = 42
    let resultKey = this.results[outputId].mapping[outputName]
    return NestedObject.find(this.results[outputId].output, resultKey)
  }

  generateParams(actionTemplate, action) {
    // action.input_mapping
    // { provider_id: "a4ae7db5-c4a8-471b-89f7-4d5ebc024e61_provider_id" }

    // actionTemplate.input
    // { provider_id: "user.providers_as_admin_ids[]" }


    let virtualParams = {}

    // Fetch output from previous actions for each input mapping

    for (let [inputName, outputReference] of Object.entries(action.input_mapping)) {
      let value = this.findPreviousOutput(outputReference)

      // paramName = "car.provider_id"
      let paramName = actionTemplate.input[inputName]
      // Might be nil, e.g. for path params skip path params for now
      if (paramName) {
        virtualParams[paramName] = value
      }
    }

    if (action.static_params) {
      for (let [inputName, value] of Object.entries(action.static_params)) {
        let key = actionTemplate.input[inputName]
        virtualParams[key] = value
      }
    }

    // TODO: handle missing inputs
    let params;
    if (action.defaults) {
      params = _.defaultsDeep(NestedObject.build(virtualParams), action.defaults)
    } else {
      params = _.defaultsDeep(NestedObject.build(virtualParams), actionTemplate.defaults)
    }

    params = this.applyTraits(params, action)

    params = FakeParams.apply(params)


    return params
  }

  applyTraits(params, action) {
    if (action.runtime_traits) {
      for(let traitUuid of this.runtimeOptions.traits) {
        let trait = action.template().traits[traitUuid]
        if (trait) {
          let traitParams = Object.assign({}, trait.params)
          params = _.defaultsDeep({}, trait.params, params)
        }
      }
    } else if(action.traits && action.traits.length > 0) {
      for(let traitUuid of action.traits) {
        let trait = action.template().traits[traitUuid]
        if (trait) {
          let traitParams = Object.assign({}, trait.params)
          params = _.defaultsDeep({}, trait.params, params)
        }
      }
    }
    return params
  }

}

export default WorkflowRunner
